'use client';

import { useCookiebot } from '@/components/organisms/CookieModal/utils/useCookiebot';

const CookieModalPL = () => {
    useCookiebot();

    return <></>;
};

export default CookieModalPL;
